import { render, staticRenderFns } from "./BotaoComponent.vue?vue&type=template&id=e556d880&scoped=true&lang=pug"
import script from "./BotaoComponent.vue?vue&type=script&lang=js"
export * from "./BotaoComponent.vue?vue&type=script&lang=js"
import style0 from "./BotaoComponent.vue?vue&type=style&index=0&id=e556d880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e556d880",
  null
  
)

export default component.exports